import { render, staticRenderFns } from "./PopoverActions.vue?vue&type=template&id=2199af81&"
import script from "./PopoverActions.vue?vue&type=script&lang=js&"
export * from "./PopoverActions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports